import { Box } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'
import { useStyles } from './styles'

interface ITableInfo {
  title: string
  subTitle?: string
  route?: string
}

const TableInfo: React.FC<ITableInfo> = ({ title, route = '', subTitle = '' }) => {
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      <Box className={classes.hero}>
        <span className={classes.title}>{title}</span>
        {subTitle != '' && <span className={classes.subtitle}>{subTitle}</span>}
      </Box>
      {route != '' && (
        <Link
          to={route}
          className={classes.button}
        >{`Criar ${title.toLowerCase()}`}</Link>
      )}
    </Box>
  )
}

export default TableInfo
